import { Component, ElementRef, inject } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { AppMenuComponent } from './app.menu.component';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [AppMenuComponent],
  templateUrl: './app.sidebar.component.html',
})
export class AppSidebarComponent {
  readonly layoutService = inject(LayoutService);
  readonly el = inject(ElementRef);
}
